import React, {FC} from 'react'

type Props = {
  phone?: string
}

const UserLocationCell: FC<Props> = ({phone}) => {
  return <div className='badge badge-light fw-bolder'>{'15C street 4, New York'}</div>
}

export default UserLocationCell
